export enum Authorities {
  // user
  CREATE_CMS_USER = "CREATE_CMS_USER",
  UPDATE_CMS_USER = "UPDATE_CMS_USER",
  LIST_CMS_USER = "LIST_CMS_ROLE",
  // Role
  CREATE_CMS_ROLE = "CREATE_CMS_ROLE",
  UPDATE_CMS_ROLE = "UPDATE_CMS_ROLE",
  LIST_CMS_ROLE = "LIST_CMS_ROLE",
  // Role
  CREATE_CMS_PERMISSION = "CREATE_CMS_PERMISSION",
  UPDATE_CMS_PERMISSION = "UPDATE_CMS_PERMISSION",
  LIST_CMS_PERMISSION = "LIST_CMS_PERMISSION",
  //commercial membership
  CREATE_COMMERCIAL_MEMBERSHIP = "CREATE_COMMERCIAL_MEMBERSHIP",
  UPDATE_COMMERCIAL_MEMBERSHIP = "UPDATE_COMMERCIAL_MEMBERSHIP",
  LIST_COMMERCIAL_MEMBERSHIP = "LIST_COMMERCIAL_MEMBERSHIP",
  //commercial package
  CREATE_COMMERCIAL_PACKAGE = "CREATE_COMMERCIAL_PACKAGE",
  UPDATE_COMMERCIAL_PACKAGE = "UPDATE_COMMERCIAL_PACKAGE",
  LIST_COMMERCIAL_PACKAGE = "LIST_COMMERCIAL_PACKAGE",
  //commercial membership duration
  CREATE_COMMERCIAL_MEMBERSHIP_DURATION = "CREATE_COMMERCIAL_MEMBERSHIP_DURATION",
  UPDATE_COMMERCIAL_MEMBERSHIP_DURATION = "UPDATE_COMMERCIAL_MEMBERSHIP_DURATION",
  LIST_COMMERCIAL_MEMBERSHIP_DURATION = "LIST_COMMERCIAL_MEMBERSHIP_DURATION",
  //dcdd membership
  CREATE_DCDD_MEMBERSHIP_PLAN = "CREATE_DCDD_MEMBERSHIP_PLAN",
  UPDATE_DCDD_MEMBERSHIP_PLAN = "UPDATE_DCDD_MEMBERSHIP_PLAN",
  LIST_DCDD_MEMBERSHIP_PLAN = "LIST_DCDD_MEMBERSHIP_PLAN",
  //membership plan
  CREATE_MEMBERSHIP_PLAN = "CREATE_MEMBERSHIP_PLAN",
  UPDATE_MEMBERSHIP_PLAN = "UPDATE_MEMBERSHIP_PLAN",
  LIST_MEMBERSHIP_PLAN = "LIST_MEMBERSHIP_PLAN",
  //commercial user
  CREATE_COMMERCIAL_USER = "CREATE_COMMERCIAL_USER",
  UPDATE_COMMERCIAL_USER = "UPDATE_COMMERCIAL_USER",
  LIST_COMMERCIAL_USER = "LIST_COMMERCIAL_USER",
  //dcdd user
  CREATE_DCDD_USER = "CREATE_DCDD_USER",
  UPDATE_DCDD_USER = "UPDATE_DCDD_USER",
  LIST_DCDD_USER = "LIST_DCDD_USER",
  //bulk_registration
  CREATE_BULK_REGISTRATION = "CREATE_BULK_REGISTRATION",
  //faq
  CREATE_FAQ = "CREATE_FAQ",
  UPDATE_FAQ = "UPDATE_FAQ",
  LIST_FAQ = "LIST_FAQ",
  //video
  CREATE_FEATURED_ADS = "CREATE_FEATURED_ADS",
  LIST_FEATURED_ADS = "LIST_FEATURED_ADS",
  UPDATE_FEATURED_ADS = "UPDATE_FEATURED_ADS",
  //coupon
  CREATE_COUPON = "CREATE_COUPON",
  REDEEM_COUPON = "REDEEM_COUPON",
  LIST_COUPON = "LIST_COUPON",
  //group
  CREATE_GROUP = "CREATE_GROUP",
  LIST_GROUP = "LIST_GROUP",
  UPDATE_GROUP = "UPDATE_GROUP",
  //series
  CREATE_SERIES = "CREATE_SERIES",
  LIST_SERIES = "LIST_SERIES",
  UPDATE_SERIES = "UPDATE_SERIES",
  //category
  CREATE_CATEGORY = "CREATE_CATEGORY",
  LIST_CATEGORY = "LIST_CATEGORY",
  UPDATE_CATEGORY = "UPDATE_CATEGORY",
  //season
  CREATE_SEASON = "CREATE_SEASON",
  LIST_SEASON = "LIST_SEASON",
  UPDATE_SEASON = "UPDATE_SEASON",
  //episode
  CREATE_EPISODE = "CREATE_EPISODE",
  LIST_EPISODE = "LIST_EPISODE",
  UPDATE_EPISODE = "UPDATE_EPISODE",
  //video
  CREATE_VIDEO = "CREATE_VIDEO",
  LIST_VIDEO = "LIST_VIDEO",
  UPDATE_VIDEO = "UPDATE_VIDEO",
  //ReadingMaterial
  CREATE_READING_MATERIAL = "CREATE_READING_MATERIAL",
  //Q and A
  CREATE_QUESTION_AND_ANSWER = "CREATE_QUESTION_AND_ANSWER",
  //Reports
  LIST_DCDD_ACTIVE_USER = "LIST_DCDD_ACTIVE_USER",
  LIST_COMMERCIAL_ACTIVE_USER = "LIST_COMMERCIAL_ACTIVE_USER",
  LIST_DCDD_NEW_REGISTARTION = "LIST_DCDD_NEW_REGISTARTION",
  LIST_COMMERCIAL_NEW_REGISTARTION = "LIST_COMMERCIAL_NEW_REGISTARTION",
  LIST_EMAIL_LOGS = "LIST_EMAIL_LOGS",
  LIST_SMS_LOGS = "LIST_SMS_LOGS",
  LIST_RMA_PAYMENT = "LIST_RMA_PAYMENT",
  LIST_STRIPE_PAYMENT = "LIST_STRIPE_PAYMENT",
  LIST_VIDEO_COUNT = "LIST_VIDEO_COUNT",
  //module
  LIST_MODULE = "LIST_MODULE",
}
